import "./updateForm.css";
import sendIcon from "./images/Send.png";
import Button from "./Button/Button";
import { useRef } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const UpdateForm = ({
  setUpdateChecked,
  updateChecked,
  setFiles,
  setNewFiles,
  location,
}) => {
  const titleRef = useRef();
  const textRef = useRef();
  const { baseUrl } = useGlobalContext();
  const { apiKey, loggedUser } = useGlobalContext();

  const handleUpdate = async () => {
    const newTitle = titleRef.current.value;
    const newText = textRef.current.value;
    if (updateChecked.isAdding) {
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/updatePendingDocument.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            location_id: location.location_id,
            location_document_pending_id: updateChecked.file.id,
            ld_name: newTitle,
            ld_description: newText,
          }
        );

        console.log(data);
        if (data.status === 200)
          setNewFiles((prev) => {
            return prev.map((f) => {
              if (f.id === updateChecked.file.id)
                return {
                  ...updateChecked.file,
                  title: newTitle,
                  text: newText,
                };
              else return f;
            });
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/updateDocument.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            location_id: location.location_id,
            location_document_id: updateChecked.file.id,
            ld_name: newTitle,
            ld_description: newText,
          }
        );

        console.log(data);
        if (data.status === 200)
          setFiles((prev) => {
            return prev.map((f) => {
              if (f.id === updateChecked.file.id)
                return {
                  ...updateChecked.file,
                  title: newTitle,
                  text: newText,
                };
              else return f;
            });
          });
      } catch (error) {
        console.log(error);
      }
    }
    setUpdateChecked({
      value: false,
      file: undefined,
      isAdding: false,
    });
  };

  return (
    <>
      <div className="update-form">
        <textarea
          ref={titleRef}
          className="update-form-input"
          defaultValue={updateChecked.file.title}
          rows={2}
          key={updateChecked.file.title}
        />
        <div className="update-form-btn" onClick={handleUpdate}>
          <Button image={sendIcon} />
        </div>
        <input
          defaultValue={updateChecked.file.text}
          ref={textRef}
          className="update-form-text"
        />
      </div>
    </>
  );
};

export default UpdateForm;
